import { Template } from '@/models/entity/template/Template'
import { TemplateMapped } from '@/models/entity/template/TemplateMapped'

export const mapDtoToTemplateMessage = (dto: Template): TemplateMapped => ({
  id: dto.id,
  text: dto.text,
  title: dto.title,
  createdAt: dto.created_at
})
